export enum PeriodicityTypes {
  OFTEN = 3,
  SOMETIMES = 2,
  NEVER = 1,
  UNSET = 0,
}

export type PeriodicityResponse = {
  periodicity: PeriodicityTypes;
  product: number;
};
